<template>
<el-container>
    <el-aside width="200px"></el-aside>
    <el-main>
    <el-card class="card">
        <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-s-order" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Identify Result</span>
            <el-button type="primary" icon="el-icon-download" size="medium" @click="exportCsv" class="custom-button">Download</el-button>
        </div>
        </template>
        <div>
        <el-table :data="paginationData" border style="width:100%;color:black;" empty-text="No data available." fit>
            <el-table-column prop="region" label="region"></el-table-column>
            <el-table-column prop="gene_name" label="gene_name"></el-table-column>
            <el-table-column prop="gene_chromosome" label="chromosome" width="200px"></el-table-column>
            <el-table-column prop="gene_start" label="start"></el-table-column>
            <el-table-column prop="gene_end" label="end"></el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px; text-align: center;"
            :current-page="currentPageRange"
            :page-size="pageSize"
            :total="tableData.length"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
        ></el-pagination>
        </div>
    </el-card>
    </el-main>
    <el-aside width="200px"></el-aside>
</el-container>
</template>

<script>
export default {
data() {
    return {
    tableData: [],
    currentPage: 1,
    pageSize: 10,
    dataArray: [], // 定义并初始化一个空数组
    region:'',
    gene_name: '',
    gene_chromosome: '',
    gene_start: '',
    gene_end: '',
    closest_genes: [] // 添加 closest_genes 并初始化为空数组
    };
},
computed: {
    pageCount() {
    return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginationData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.tableData.slice(start, end);
    },
    currentPageRange() {
    return Math.max(1, Math.min(this.currentPage, this.pageCount));
    }
},
mounted() {
    // 从路由参数中获取数据,获取最近基因数据
    this.closest_genes = this.$route.params.res.closest_genes;

    // 遍历closest_genes数组，添加数据到tableData数组
    this.closest_genes.forEach(closest_genes => {
        const rowData = {
            region: closest_genes.region,
            gene_name: closest_genes.closest_gene,
            gene_chromosome: closest_genes.gene_chromosome,
            gene_start: closest_genes.gene_start,
            gene_end: closest_genes.gene_end
        };
        this.tableData.push(rowData);
    });

    // 更新当前页码
    this.handleCurrentChange(1);
},
methods: {
    handleCurrentChange(val) {
    this.currentPage = val;
    },
    exportCsv() {
    const header = ['region','gene_name', 'chromosome', 'start', 'end'];
    const data = this.tableData.map(row => ({
        region: row.region,
        gene_name: row.gene_name,
        chromosome: row.gene_chromosome,
        start: row.gene_start,
        end: row.gene_end
    }));
    const csv = [
        header.join(','),
        ...data.map(row => Object.values(row).join(','))
    ].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'gene_data.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    }
}
};
</script>

<style scoped>
.card {
    margin-top: 60px;
    border-color: #010c0c;
}
.clearfix {
    font-size: larger;
}
.custom-button {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
</style>


// WEBPACK FOOTER //
// src/components/closestgene/Closestgenebedlist.vue